import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Certificate } from "src/app/models/certificate.model";
import { User } from "src/app/models/user.model";
import { CertificatesService } from "src/app/services/certificates.service";
import { RegmembersService } from "src/app/services/regmembers.service";

@Component({
  selector: "app-member-certificate",
  templateUrl: "./member-certificate.component.html",
  styleUrls: ["./member-certificate.component.css"],
})
export class MemberCertificateComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private regmembersService: RegmembersService,
    private certificatesService: CertificatesService
  ) { }

  memberName: string;
  courseId: number;
  member: User;
  certificate: Certificate;
  certName: string;

  displayDialog = true;
  loading = true;
  errorMessage;
  successMessage;

  ngOnInit() {
    this.activatedRoute.params.subscribe(async (params) => {
      this.memberName = params["membername"];
      this.courseId = parseInt(params["courseId"]);
      await this.load();
    });
  }

  async load() {
    this.loading = true;
    this.member = await this.regmembersService.getUserBy(this.memberName);
    const certificates = await this.certificatesService.getCertificateByCourseIdAndMemberId(this.courseId, this.member.memberid);
    this.certificate = certificates && certificates.length > 0 ? certificates[0] : null;
    this.certName = this.certificate ? this.certificate.cert_name : "";
    this.loading = false;
  }

  async save() {
    try {
      await this.certificatesService.updateCertificate(this.courseId, this.member.memberid, this.certName);
      this.certificate.cert_name = this.certName;
      this.successMessage = "Certificate updated successfully";
      this.errorMessage = null;
    } catch (err) {
      this.successMessage = null;
      this.errorMessage = (err && err.error && err.error.error && err.error.error.description)
        ? err.error.error.description
        : "Unable to update certificate";
    }
  }

  goBack() {
    this.router.navigate(["admin", "regmembers", this.memberName, "courses"]);
  }

  handleClose() {
    if (!this.displayDialog) {
      this.goBack();
    }
  }
}
